<template>
  <v-container class="text-center setting">
    <div class="text-left">
      <app-button label="Save" padding="pa-2 px-4" @click="save()"></app-button>
    </div>
    <div class="mb-3 text-h6">
      Category
      <app-button
        icon="mdi-plus"
        class="ml-3"
        @click="addCategory()"
      ></app-button>
    </div>
    <draggable
      class="row"
      v-model="categories"
      animation="200"
      delay="250"
      delayOnTouchOnly
      handle=".my-handle"
    >
      <v-col v-for="(category, index) in categories" :key="index" cols="4">
        <task-panel
          class="my-handle"
          :label="category.label"
          :icon="category.icon"
          iconColor="#e200ff"
          @click="editCategory(index, category)"
        />
      </v-col>
    </draggable>
    <v-divider class="my-5"></v-divider>
    <div class="mb-3 text-h6">
      Task
      <app-button icon="mdi-plus" class="ml-3" @click="addTask()"></app-button>
    </div>
    <draggable
      class="row"
      v-model="tasks"
      animation="200"
      delay="250"
      delayOnTouchOnly
      handle=".my-handle"
    >
      <v-col v-for="(task, index) in tasks" :key="index" cols="4">
        <task-panel
          class="my-handle"
          :label="task.label"
          :icon="task.icon"
          iconColor="#00ffe2"
          @click="editTask(index, task)"
        />
      </v-col>
    </draggable>
    <v-dialog v-model="dialog">
      <v-card color="#efefef">
        <v-card-title class="d-flex justify-space-between">
          {{ editItem.title }}
          <span>
            <v-btn icon x-large color="error" @click="remove()"
              ><v-icon>mdi-delete-outline</v-icon></v-btn
            >
            <v-btn icon x-large @click="apply()"
              ><v-icon>mdi-content-save-outline</v-icon></v-btn
            >
          </span>
        </v-card-title>
        <v-card-text>
          <div class="d-flex">
            <task-panel
              :label="editItem.label"
              :icon="editItem.icon"
              class="mb-3 mr-5"
            ></task-panel>
            <v-text-field v-model="editItem.label" label="Label"></v-text-field>
          </div>
          <div style="max-height:500px; overflow-y:auto">
            <v-btn
              class="py-8 px-0 mx-1"
              color="transparent"
              v-bind:class="{ selected: icon === editItem.icon }"
              outlined
              v-for="(icon, index) in icons"
              :key="index"
              elevation="0"
              @click="editItem.icon = icon"
            >
              <v-icon large color="#616161">{{ icon }}</v-icon>
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" timeout="2000" bottom color="primary"
      >Saved!</v-snackbar
    >
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import TaskPanel from "../components/TaskPanel";
import AppButton from "../components/AppButton";

export default {
  name: "Setting",

  components: {
    draggable,
    TaskPanel,
    AppButton,
  },
  data() {
    return {
      dialog: false,
      snackbar: false,
      categories: [],
      tasks: [],
      editItem: {
        title: "",
        label: "",
        icon: "",
        index: 0,
      },
      icons: [
        "mdi-domain",
        "mdi-truck-outline",
        "mdi-file-outline",
        "mdi-credit-card-outline",
        "mdi-cash-100",
        "mdi-currency-usd",
        "mdi-home-variant-outline",
        "mdi-email-outline",
        "mdi-forum-outline",
        "mdi-file-find-outline",
        "mdi-phone-outline",
        "mdi-book-open-blank-variant",
        "mdi-magnify",
        "mdi-code-tags",
        "mdi-format-list-checkbox",
        "mdi-vacuum-outline",
        "mdi-walk",
        "mdi-food-outline",
        "mdi-smoking",
        "mdi-coffee",
        "mdi-sleep",
        "mdi-alert",
        "mdi-cached",
        "mdi-camera",
        "mdi-car-outline",
        "mdi-cart-outline",
        "mdi-chart-timeline-variant",
        "mdi-city",
        "mdi-cloud-download-outline",
        "mdi-cloud-upload-outline",
        "mdi-cog-outline",
        "mdi-delete-outline",
        "mdi-hammer-wrench",
        "mdi-heart-outline",
        "mdi-help-circle-outline",
        "mdi-hospital-box",
        "mdi-inbox",
        "mdi-key-outline",
        "mdi-label-outline",
        "mdi-pencil-outline",
        "mdi-printer",
        "mdi-smoking",
        "mdi-store-outline",
        "mdi-web",
      ],
    };
  },
  methods: {
    addCategory() {
      this.categories.push({
        active: false,
        label: "new item",
        icon: "mdi-file-outline",
      });
    },
    addTask() {
      this.tasks.push({
        active: false,
        label: "new item",
        icon: "mdi-file-outline",
      });
    },
    editCategory(index, item) {
      this.editItem.active = item.active;
      this.editItem.title = "Edit Category";
      this.editItem.label = item.label;
      this.editItem.icon = item.icon;
      this.editItem.index = index;
      this.dialog = true;
    },
    editTask(index, item) {
      this.editItem.active = item.active;
      this.editItem.title = "Edit Task";
      this.editItem.label = item.label;
      this.editItem.icon = item.icon;
      this.editItem.index = index;
      this.dialog = true;
    },
    apply() {
      if(this.editItem.active === true){
        window.alert('記録中のパネルは編集できません。');
        return;
      }
      if (this.editItem.title === "Edit Task") {
        this.tasks[this.editItem.index].label = this.editItem.label;
        this.tasks[this.editItem.index].icon = this.editItem.icon;
      } else {
        this.categories[this.editItem.index].label = this.editItem.label;
        this.categories[this.editItem.index].icon = this.editItem.icon;
      }
      this.dialog = false;
    },
    remove() {
      if(this.editItem.active === true){
        window.alert('記録中のパネルは編集できません。');
        return;
      }
      if (this.editItem.title === "Edit Task") {
        this.tasks.splice(this.editItem.index, 1);
      } else {
        this.categories.splice(this.editItem.index, 1);
      }
      this.dialog = false;
    },
    save() {
      this.$store.dispatch("saveCategories", this.categories);
      this.$store.dispatch("saveTasks", this.tasks);
      this.snackbar = true;
    },
    openIconList() {},
  },
  created() {
    this.categories = JSON.parse(JSON.stringify(this.$store.state.categories));
    this.tasks = JSON.parse(JSON.stringify(this.$store.state.tasks));
    //this.categories.forEach((x) => (x.active = false));
    //this.tasks.forEach((x) => (x.active = false));
  },
};
</script>
<style scoped>
::v-deep .v-btn--outlined.selected {
  border: solid orange;
}
::v-deep .v-btn--outlined {
  border: solid transparent;
}
</style>